import { Sprite, SpriteFrameSize, spriteFrameSize } from 'utilities';

export const getStyleAttr = (frameNumber: number, project, size: SpriteFrameSize) => {
  const framesPerLine = Sprite.getFramesPerLine(size);
  const framesPerColumn = Sprite.getFramesPerColumn(size);
  const backgroundSize = `${framesPerLine * 100}% ${framesPerColumn * 100}%`;
  const calcFrameNumber = frameNumber - 1;
  const percentageOffsetPerFrame = 100 / (framesPerLine - 1);
  const percentageOffsetPerLine = 100 / (framesPerColumn - 1);
  const X = calcFrameNumber % framesPerLine * percentageOffsetPerFrame + '%';
  const Y = Math.floor(calcFrameNumber / framesPerLine) % framesPerColumn * percentageOffsetPerLine + '%';

  const width = {
    [spriteFrameSize.xxs]: 80,
    [spriteFrameSize.xs]: 140,
    [spriteFrameSize.s]: 150,
    [spriteFrameSize.m]: 280,
    [spriteFrameSize.l]: 900
  }[size] || 150;
  const height = width / 16 * 9;

  const url = Sprite.getUrl(frameNumber, project, size);

  return { url, backgroundSize, X, Y, width, height };
};

export const getImage = url => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({ url, img });
    };
    img.onerror = () => {
      reject(url);
    };
    img.src = url;
  });
};
